const mPaginationPrimary = {
  mPaginationPrimary: {
    alerts: {
      showLoadingState: {
        loading: 'Cargando Datos...'
      }
    },

    messagesPages: {
      first: 'Primero',
      next: 'Siguiente',
      last: 'Último',
      previous: 'Anterior'
    },

    messagesQuantity: {
      noResults: 'No se encontraron resultados',
      of: 'de',
      results: 'resultados',
      showing: 'Mostrando',
      to: 'a'
    },

    messagesState: {
      loading: 'Cargando Datos...'
    }
  }
}

export default mPaginationPrimary
